import {
    SET_EXPENSE_CONFIG,
    SET_EXPENSE_TYPES,
    RESET_ALL
} from '../actions/action-types';

const initialState = {
    expenseConfig: null,
    expenseTypes: null
}

export const expenseConfigReducer = (state = initialState, action) => {
    let newState = Object.assign({}, state);
    switch (action.type) {

        case SET_EXPENSE_CONFIG:
            newState["expenseConfig"] = action.payload.expenseConfig;
            newState["expenseTypes"] = action.payload.expenseTypes;
            return newState;

        case SET_EXPENSE_TYPES:
            newState["expenseTypes"] = action.payload.expenseTypes;
            return newState;

        case RESET_ALL:
            newState["expenseConfig"] = null;
            newState["expenseTypes"] = null;
            return newState;

        default:
            return state;
    }
}
